import * as client_hooks from '../../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74'),
	() => import('./nodes/75'),
	() => import('./nodes/76'),
	() => import('./nodes/77'),
	() => import('./nodes/78'),
	() => import('./nodes/79'),
	() => import('./nodes/80'),
	() => import('./nodes/81'),
	() => import('./nodes/82'),
	() => import('./nodes/83'),
	() => import('./nodes/84'),
	() => import('./nodes/85'),
	() => import('./nodes/86'),
	() => import('./nodes/87'),
	() => import('./nodes/88'),
	() => import('./nodes/89'),
	() => import('./nodes/90'),
	() => import('./nodes/91'),
	() => import('./nodes/92'),
	() => import('./nodes/93'),
	() => import('./nodes/94'),
	() => import('./nodes/95'),
	() => import('./nodes/96'),
	() => import('./nodes/97'),
	() => import('./nodes/98'),
	() => import('./nodes/99'),
	() => import('./nodes/100'),
	() => import('./nodes/101'),
	() => import('./nodes/102'),
	() => import('./nodes/103'),
	() => import('./nodes/104'),
	() => import('./nodes/105'),
	() => import('./nodes/106'),
	() => import('./nodes/107'),
	() => import('./nodes/108')
];

export const server_loads = [0,2,4,5,8,7];

export const dictionary = {
		"/(app)": [~9,[2],[3]],
		"/(app)/admin": [~10,[4]],
		"/(app)/admin/analytics": [11,[4]],
		"/(app)/admin/application-settings": [12,[4]],
		"/(app)/admin/changelog": [~13,[4]],
		"/(app)/admin/changelog/new": [15,[4]],
		"/(app)/admin/changelog/[id]/edit": [~14,[4]],
		"/(app)/admin/chronos": [~16,[4]],
		"/(app)/admin/chronos/new": [~18,[4]],
		"/(app)/admin/chronos/[id]/edit": [~17,[4]],
		"/(app)/admin/contact": [~19,[4]],
		"/(app)/admin/contact/chat/[id]": [~20,[4]],
		"/(app)/admin/dropin": [~21,[4]],
		"/(app)/admin/dropin/chat/[id]": [~22,[4]],
		"/(app)/admin/event-groups": [~23,[4]],
		"/(app)/admin/event-groups/new": [~25,[4]],
		"/(app)/admin/event-groups/[id]/edit": [~24,[4]],
		"/(app)/admin/event-types": [~26,[4]],
		"/(app)/admin/event-types/new": [~28,[4]],
		"/(app)/admin/event-types/[id]/edit": [~27,[4]],
		"/(app)/admin/exercises": [~29,[4]],
		"/(app)/admin/exercises/new": [~31,[4]],
		"/(app)/admin/exercises/[id]": [~30,[4]],
		"/(app)/admin/followed-program": [~32,[4]],
		"/(app)/admin/followed-program/new": [~36,[4]],
		"/(app)/admin/followed-program/[id]/configuration": [~33,[4]],
		"/(app)/admin/followed-program/[id]/configuration/workout": [~34,[4]],
		"/(app)/admin/followed-program/[id]/edit": [~35,[4]],
		"/(app)/admin/leaderboard": [~37,[4]],
		"/(app)/admin/notifications-history": [~38,[4]],
		"/(app)/admin/personal-programs": [~39,[4]],
		"/(app)/admin/program-categories": [~40,[4]],
		"/(app)/admin/program-categories/new": [~42,[4]],
		"/(app)/admin/program-categories/[id]/edit": [~41,[4]],
		"/(app)/admin/roles": [~43,[4]],
		"/(app)/admin/roles/new": [~45,[4]],
		"/(app)/admin/roles/[id]/edit": [~44,[4]],
		"/(app)/admin/try-contact": [~46,[4]],
		"/(app)/admin/try-contact/chat/[id]": [~47,[4]],
		"/(app)/admin/upcoming-events": [~48,[4]],
		"/(app)/admin/users": [~49,[4]],
		"/(app)/admin/users/[id]": [~50,[4,5]],
		"/(app)/admin/users/[id]/contract": [~51,[4,5]],
		"/(app)/admin/users/[id]/permissions": [~52,[4,5]],
		"/(app)/admin/users/[id]/personal-best": [~53,[4,5]],
		"/(app)/admin/users/[id]/personal-program": [~54,[4,5]],
		"/(app)/admin/users/[id]/personal-program/edit": [~57,[4,5]],
		"/(app)/admin/users/[id]/personal-program/new": [~58,[4,5]],
		"/(app)/admin/users/[id]/personal-program/[programId]": [~55,[4,5]],
		"/(app)/admin/users/[id]/personal-program/[programId]/session/[sessionId]": [~56,[4,5]],
		"/(app)/admin/users/[id]/programs": [~59,[4,5]],
		"/(app)/admin/weekly-program": [~60,[4]],
		"/(app)/admin/wod-calendar/new": [~62,[4]],
		"/(app)/admin/wod-calendar/[id]": [~61,[4]],
		"/(app)/calendar": [~63,[2],[3]],
		"/(app)/changelog": [~64,[2],[3]],
		"/(app)/changelog/[version]": [~65,[2],[3]],
		"/chat/not-found": [105],
		"/chat/[id]": [~104],
		"/(app)/chrono": [~66,[2],[3]],
		"/(app)/chrono/hyrox": [~68,[2],[3]],
		"/(app)/chrono/start-[templateId]": [~69,[2],[3]],
		"/(app)/chrono/[id]": [~67,[2],[3]],
		"/dev/mail-viewer": [106],
		"/(app)/followed-program/[id]": [~70,[2],[3]],
		"/(app)/init-birthday": [~71],
		"/init-password": [~107],
		"/(app)/install-app": [72,[2],[3]],
		"/(auth)/login": [~98,[8]],
		"/(auth)/login/verify-totp": [~99,[8]],
		"/(auth)/logout": [100,[8]],
		"/(app)/month-calendar": [73,[2],[3]],
		"/(app)/my-workouts": [~74,[2],[3]],
		"/(app)/my-workouts/[id]": [~75,[2],[3]],
		"/(auth)/password/request": [~101,[8]],
		"/(auth)/password/reset": [~102,[8]],
		"/(app)/payment/canceled": [76,[2],[3]],
		"/(app)/payment/success": [~77,[2],[3]],
		"/(app)/personal-best": [~78,[2],[3]],
		"/(app)/personal-best/[id]": [~79,[2],[3]],
		"/(app)/personal-program": [~80,[2],[3]],
		"/(app)/personal-program/[sessionId]/feedback": [~81,[2],[3]],
		"/(app)/personal-program/[sessionId]/recap": [~82,[2],[3]],
		"/(app)/personal-program/[sessionId]/sections/[sectionId]": [~83,[2],[3]],
		"/(app)/personal-program/[sessionId]/start": [~84,[2],[3]],
		"/(app)/profile/followed-programs": [~85,[2,6],[3]],
		"/(app)/profile/membership": [~86,[2,6],[3]],
		"/(app)/profile/membership/choose": [~87,[2,6],[3]],
		"/(app)/profile/notifications": [~88,[2,6],[3]],
		"/(app)/profile/payments": [~89,[2,6],[3]],
		"/(app)/profile/profile": [~90,[2,6],[3]],
		"/(app)/profile/security": [~91,[2,6],[3]],
		"/(app)/profile/subscriptions": [~92,[2,6],[3]],
		"/(app)/program": [93,[2],[3]],
		"/(auth)/register-90dk3eiozMLKSzhsj": [~103,[8]],
		"/signup/success": [~108],
		"/(app)/user-workouts/[id]/finalize": [~94,[2,7],[3]],
		"/(app)/user-workouts/[id]/sections/[sectionId]": [~95,[2,7],[3]],
		"/(app)/user-workouts/[id]/start": [96,[2,7],[3]],
		"/(app)/users/[id]": [~97,[2],[3]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ kind, error }) => { if (kind === 'unknown') { console.error(error); } }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export const get_error_template = () => import('../shared/error-template.js').then(m => m.default);